export function normalizeFarmerMatchKey(value) {
  if (value == null) {
    return '';
  }
  return String(value)
    .trim()
    .replace(/\s+/g, '')
    .replace(/^\+233/, '0')
    .toLowerCase();
}

export function keyFromPhotoFilename(filename) {
  const base = String(filename || '').split(/[/\\]/).pop() || '';
  return normalizeFarmerMatchKey(base.replace(/\.[^.]+$/i, ''));
}

function detectMatchField(farmer, key) {
  if (normalizeFarmerMatchKey(farmer.ID) === key) {
    return 'ID';
  }
  if (normalizeFarmerMatchKey(farmer.contact) === key) {
    return 'contact';
  }
  if (normalizeFarmerMatchKey(farmer.idnumber) === key) {
    return 'idnumber';
  }
  if (normalizeFarmerMatchKey(farmer._id) === key) {
    return '_id';
  }
  return null;
}

/**
 * Match a photo filename to a farmer record.
 * Returns preview rows for the bulk-import UI.
 */
export function matchFarmerPhotoFile(farmers, filename) {
  const key = keyFromPhotoFilename(filename);
  if (!key) {
    return {
      status: 'invalid',
      key,
      filename,
      label: 'Invalid filename',
    };
  }

  const matches = (farmers || []).filter((farmer) => detectMatchField(farmer, key));

  if (matches.length === 0) {
    return {
      status: 'unmatched',
      key,
      filename,
      label: 'No match',
    };
  }

  if (matches.length > 1) {
    return {
      status: 'duplicate',
      key,
      filename,
      label: 'Multiple matches',
      farmers: matches,
    };
  }

  const farmer = matches[0];
  return {
    status: 'ready',
    key,
    filename,
    label: farmer.farmername || 'Matched',
    farmer,
    matchField: detectMatchField(farmer, key),
  };
}
